import "babel-polyfill";

import PageController from './Controller/PageController';

// initialise foundation js
$(document).foundation();

$(document).ready(function() {
	// pass ready event to the PageController
	PageController.onReady();

	// initialise fancybox links
	$('a[class*=fancybox],a[class*=lightbox],a[rel*=fancybox]').fancybox({
			live: false
		}
	);

	$('.news-list-view.owl-carousel').on('postequalized.zf.equalizer', function(e) {
		$(this).addClass('equalized owl-carousel');
	});

	var eq;

	$('.news-list-view.owl-carousel').owlCarousel({
		dots: true,
		nav: true,
		margin: 30,
		navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
		onInitialized: function(e) {
			new Foundation.Equalizer($('.news-list-view.owl-carousel')).applyHeight();
		},
		onTranslate: function() {
			$('.news-list-view.owl-carousel').find('.news-text').css('height','');
			$('.news-list-view.owl-carousel').removeClass('equalized');

			$('.news-list-view.owl-carousel').foundation('destroy');

			new Foundation.Equalizer($('.news-list-view.owl-carousel')).applyHeight();
		},
		responsive: {
			0: {
				items: 1
			},
			500: {
				items: 2
			},
			1024: {
				items: 3
			}
		}
	});

    $('.events-view.owl-carousel').owlCarousel({
        dots: true,
        nav: true,
        margin: 30,
        navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
        responsive: {
            0: {
                items: 1
            },
            650: {
                items: 2
            },
            1024: {
                items: 3
            }
        }
    });
});